import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=7fc75c20&scoped=true&"
import script from "./AboutComponent.vue?vue&type=script&lang=js&"
export * from "./AboutComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutComponent.vue?vue&type=style&index=0&id=7fc75c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc75c20",
  null
  
)

export default component.exports